import React from "react";
import { InputDiv } from "../../assets/StyledComponent/Input/Input.Style";

import { useStore } from "../../store";
import "../TotalExpenseReport/styles.css";
import { sCmpUserReportDownloadService, sCmpUserReportService } from "../../services/sCmpUserReportService";
import { GET_CMP_USER_REPORT_FAILURE, GET_CMP_USER_REPORT_SUCCESS } from "../../container/SCmpUserReport/types";
import { toast } from "react-toastify";
interface Iprops {
  companyId: string
}

const EnglishDateSelect = ({ companyId }: Iprops) => {
  const [state, dispatch]: any = useStore();
  const [date, setDate] = React.useState({ year: "", month: "" });
  const month = [
    {
      name: "January",
      value: "01",
    },
    {
      name: "February",
      value: "02",
    },
    {
      name: "March",
      value: "03",
    },
    {
      name: "April",
      value: "04",
    },
    {
      name: "May",
      value: "05",
    },
    {
      name: "June",
      value: "06",
    },
    {
      name: "July",
      value: "07",
    },
    {
      name: "August",
      value: "08",
    },
    {
      name: "September",
      value: "09",
    },
    {
      name: "October",
      value: "10",
    },
    {
      name: "November",
      value: "11",
    },
    {
      name: "December",
      value: "12",
    },
  ];

  const year = () => {
    let year = []
    for (let i = 2022; i <= new Date().getFullYear(); i++) {
      year.push({ name: `${i}`, value: i })
    }
    return year;
  }

  const getTableData = async () => {
    const fromDate = date && `${date.year}-${date.month}-01`;
    const toDate = date && `${date.year}-0${parseInt(date.month) + 1}-01`;

    // console.log(fromDate, toDate);

    var d = new Date(toDate);
    d.setDate(d.getDate() - 1);
    const year = d.getFullYear().toString();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const to_date = year + "_" + month + "_" + day;
    sCmpUserReportDownloadService(fromDate, to_date,companyId)
  };

  React.useEffect(() => {
    var today = new Date();
    var day = String(today.getDate()).padStart(2, "0");
    var month = String(today.getMonth() + 1).padStart(2, "0");
    var year = today.getFullYear().toString();

    setDate({ year, month });
  }, []);
  const handleUserReport = () => {
    const fromDate = date && `${date.year}-${date.month}-01`;
    const toDate = date && `${date.year}-0${parseInt(date.month) + 1}-01`;

    // console.log(fromDate, toDate);

    var d = new Date(toDate);
    d.setDate(d.getDate() - 1);
    const year = d.getFullYear().toString();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const to_date = year + "_" + month + "_" + day;
    
    sCmpUserReportService(fromDate, to_date,companyId).then((res: any) => {
        dispatch({ type: GET_CMP_USER_REPORT_SUCCESS, SCmpUserReport: res });
      })
        .catch((err) => {
            dispatch({ type: GET_CMP_USER_REPORT_FAILURE, SCmpUserReportError: err });
          toast.error("Select company");
            
        });
  }
  return (
    <InputDiv>
      <div
        className="w-80 pb-3 text-center rounded bg-white d-flex"
      >
        <label
          style={{
            whiteSpace: "nowrap",
            display: "flex",
            margin: "0px 21px",
            marginRight: "15px",
            fontWeight: "500",
          }}
        >
          Select English Year
        </label>
        <select
          style={{
            width: "8.75rem",
            padding: "0.5px 1px",

            borderRadius: "5px",
            background: "white",
          }}
          value={date.year}
          onChange={(e) => setDate({ ...date, year: e.target.value })}
        >
          {year().map((item) => (
            <option value={item.value} key={item.name}>
              {item.name}
            </option>
          ))}
        </select>
        <label
          style={{
            whiteSpace: "nowrap",
            display: "flex",
            marginLeft: "32px",
            marginRight: "17px",
            fontWeight: "500",
          }}
        >
          Select English Month
        </label>
        <select
          style={{
            width: "8.75rem",
            padding: "0.5px 1px",
            borderRadius: "5px",
            background: "white",
          }}
          value={date.month}
          onChange={(e) => setDate({ ...date, month: e.target.value })}
        >
          {month.map((item) => (
            <option value={item.value} key={item.name}>
              {item.name}
            </option>
          ))}
        </select>

        <button className="searchBtn" onClick={getTableData}>
          Download
        </button>
        <button className="searchBtn" type="button" onClick={handleUserReport}> View</button>
      </div>
    </InputDiv>
  );
};

export default EnglishDateSelect;
